import type { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { tokens, Link } from '@hotjar/hotsauce';
import { css } from '@emotion/react';

interface TrialMessageProps {
  handleTrialMessageClick: MouseEventHandler<HTMLButtonElement>;
  daysRemaining: number;
  alternateStyling?: boolean;
}

export const TrialMessage = ({
  handleTrialMessageClick,
  daysRemaining,
  alternateStyling,
}: TrialMessageProps): JSX.Element => {
  const { t } = useTranslation();

  const linkColor = alternateStyling ? tokens.color.link : tokens.color.white;
  return (
    <span data-testid="top-bar-trial-message">
      <Link
        as="button"
        kind="inline"
        css={css`
          color: ${linkColor};
          &:hover {
            color: ${linkColor};
          }
        `}
        onClick={handleTrialMessageClick}
      >
        {t('common:sitebar.top-bar-message.trial-message', { daysRemaining })}
      </Link>
    </span>
  );
};
